
    import {Options, Prop, Vue, Watch} from 'vue-property-decorator';

    @Options({emits: ['input']})
    export default class TextareaCounter extends Vue {
        @Prop({type: String, default: ''})
        value!: string;

        @Prop({type: Boolean, default: false})
        autofocus!: boolean;

        @Prop({type: String, required: true})
        name!: string;

        @Prop({type: String, default: ''})
        placeholder!: string;

        @Prop({type: Number, default: 0})
        min!: number;

        @Prop({type: Number, required: true})
        max!: number;

        @Prop({type: Number, default: 1})
        rows!: number;

        private inputValue = '';

        get count(): number {
            return (this.inputValue && this.inputValue.replace(/\s{2,}/g, ' ').length) || 0;
        }

        get isValid(): boolean {
            return !this.isTooShort && !this.isTooLong;
        }

        get isTooShort(): boolean {
            return this.count < this.min;
        }

        get isTooLong(): boolean {
            return this.count > this.max;
        }

        @Watch('value', {immediate: true})
        onValueChange(): void {
            this.inputValue = this.value;
        }

        onInput(): void {
            this.$emit('input', this.inputValue);
        }
    }
